module.exports = __webpack_public_path__ + "media/images/element/gallery-d78d9d578dc379b1676b41681e5f6f9e.svg";